import http from "./http";

export function getBalanceApi() {
    return http.get("/api/player/wallet/balance");
}
export const getWalletBalanceApi = () => http.get("/api/player/wallet/balance");